import {
  Add_City,
  Delete_One_City_data,
  Get_All_Cities,
  Get_Error,
  Get_One_City_Data,
  Update_One_City_data,
} from '../Types';
import usegetdata from '../../Hooks/useGetData';
import { useinsertdatawithoutimage } from '../../Hooks/usePostData';
import { UpdateProductdata } from '../../Hooks/useUpdateData';
import usedeletedata from '../../Hooks/useDeleteData';

//add all cities data
export const Add_City_Action = (body) => async (dispatch) => {
  try {
    const res = await useinsertdatawithoutimage(`/api/v1/Cities`, body);

    dispatch({
      type: Add_City,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all cities data
export const GetCitiesData = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Cities?active=true`);

    dispatch({
      type: Get_All_Cities,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

export const GetCitiesDataTrash = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Cities?active=false`);

    dispatch({
      type: Get_All_Cities,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get one city data
export const GetOneCityData = (id) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Cities/${id}`);

    dispatch({
      type: Get_One_City_Data,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//Update one city data
export const UpdateOneCityData = (id, body) => async (dispatch) => {
  try {
    const res = await UpdateProductdata(`/api/v1/Cities/${id}`, body);

    dispatch({
      type: Update_One_City_data,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//delete one city data
export const DeleteOneCityData = (id) => async (dispatch) => {
  try {
    const res = await usedeletedata(`/api/v1/Cities/${id}`);

    dispatch({
      type: Delete_One_City_data,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};
